export const POSTBOX_TEST_ID = 'AddressTypePostbox';
